// // // SavedCardsPreview.js - With Template Selection
// // import React, { useState, useEffect, useRef } from "react";
// // import {
// //   Modal, Button, Space, Spin, Empty, message, Card as AntCard, 
// //   Avatar, Tag, Tooltip, Select, Tabs, Badge
// // } from "antd";
// // import {
// //   DownloadOutlined, EyeOutlined, DeleteOutlined, 
// //   IdcardOutlined, CloseOutlined, PrinterOutlined,
// //   UserOutlined, PhoneOutlined, BankOutlined, TeamOutlined,
// //   GlobalOutlined, CrownOutlined, StarOutlined,
// //   QrcodeOutlined, CameraOutlined, CheckCircleOutlined,
// //   SwapOutlined, PictureOutlined
// // } from "@ant-design/icons";
// // import { request } from "../../../share/request";
// // import { linkPath } from "../../../share/helper";
// // import { getCurrentUser } from "../../../share/getProfile";
// // import { useReactToPrint } from "react-to-print";
// // import "./SavedCardsPreview.css";

// // const { Option } = Select;

// // const SavedCardsPreview = ({ visible, onClose, savedStaffList, onRemove, onClear }) => {
// //   const getProfile = getCurrentUser();
// //   const [loading, setLoading] = useState(false);
// //   const [templates, setTemplates] = useState([]);
// //   const [selectedTemplateId, setSelectedTemplateId] = useState(null);
// //   const [templateData, setTemplateData] = useState(null);
// //   const [selectedStaff, setSelectedStaff] = useState(null);
// //   const [previewVisible, setPreviewVisible] = useState(false);
// //   const [cardSize, setCardSize] = useState({ width: 540, height: 340 });
// //   const [activeTab, setActiveTab] = useState('cards');
// //   const printRef = useRef(null);
// //   const singlePrintRef = useRef(null);

// //   // Load templates on mount
// //   useEffect(() => {
// //     if (visible) {
// //       loadTemplates();
// //     }
// //   }, [visible]);

// //   // Load template when selected changes
// //   useEffect(() => {
// //     if (selectedTemplateId) {
// //       loadTemplateData(selectedTemplateId);
// //     }
// //   }, [selectedTemplateId]);

// //   // Load all available templates
// //   const loadTemplates = async () => {
// //     setLoading(true);
// //     try {
// //       const param = new URLSearchParams({ org_code: getProfile.org_code });
// //       const res = await request(`id-card-templates?${param.toString()}`, "get", {});
// //       if (res?.success && res.data.length > 0) {
// //         setTemplates(res.data);
        
// //         // Select default template first, otherwise first template
// //         const defaultTemplate = res.data.find(t => t.is_default === 1);
// //         const templateToLoad = defaultTemplate || res.data[0];
        
// //         if (!selectedTemplateId) {
// //           setSelectedTemplateId(templateToLoad.id);
// //         }
// //       }
// //     } catch (e) {
// //       console.error("Error loading templates:", e);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Load full template data with elements and images
// //   const loadTemplateData = async (templateId) => {
// //     setLoading(true);
// //     try {
// //       const res = await request(`id-card-templates/${templateId}`, "get", {});
// //       if (res?.success) {
// //         setTemplateData(res.data);
// //         setCardSize({ 
// //           width: res.data.width || 540, 
// //           height: res.data.height || 340 
// //         });
// //       }
// //     } catch (e) {
// //       console.error("Error loading template data:", e);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Get element value from staff data
// //   const getElementValue = (element, staff) => {
// //     const valueMap = {
// //       'fullname': staff.fullname || '',
// //       'frontname': staff.frontname || '',
// //       'staffname_eng': staff.staffname_eng || '',
// //       'idnumber': staff.idnumber || '',
// //       'gender': staff.gender || '',
// //       'dob': staff.dob ? formatDate(staff.dob) : '',
// //       'position_name': staff.position_name || '',
// //       'department_name': staff.department_name || '',
// //       'skill_name': staff.skill_name || '',
// //       'jobstatus': staff.jobstatus || '',
// //       'stafftype': staff.stafftype || '',
// //       'level': staff.level || '',
// //       'joinwork': staff.joinwork ? formatDate(staff.joinwork) : '',
// //       'username': staff.idnumber || staff.username || '',
// //       'phone': staff.username || '',
// //       'org_name': getProfile.org_name_kh || '',
// //       'qrcode_id': staff.qrcode_intergrate_id || staff.idnumber || '',
// //       'role_name': staff.role_name || '',
// //       'custom_text': element.custom_text || '',
// //     };
// //     return valueMap[element.element_key] || element.label || '';
// //   };

// //   // Format date
// //   const formatDate = (dateStr) => {
// //     if (!dateStr) return '';
// //     try {
// //       const date = new Date(dateStr);
// //       return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
// //     } catch {
// //       return dateStr;
// //     }
// //   };

// //   // Generate QR code
// //   const generateQRCode = (text, size) => {
// //     if (!text) return '';
// //     return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}&margin=5`;
// //   };

// //   // Get background style from template
// //   const getBackgroundStyle = () => {
// //     if (!templateData) return { backgroundColor: '#1a237e' };
// //     const tpl = templateData;
// //     let style = {};
    
// //     if (tpl.background_type === 'image' && tpl.background_image) {
// //       style.backgroundImage = `url(${linkPath}/${tpl.background_image})`;
// //       style.backgroundSize = tpl.bg_image_size === 'stretch' ? '100% 100%' : (tpl.bg_image_size || 'cover');
// //       style.backgroundPosition = tpl.bg_image_position || 'center';
// //       style.backgroundRepeat = 'no-repeat';
// //       if (tpl.bg_image_opacity && tpl.bg_image_opacity < 1) {
// //         style.opacity = tpl.bg_image_opacity;
// //       }
// //     } else if (tpl.background_type === 'gradient') {
// //       if (tpl.gradient_type === 'linear') {
// //         style.background = `linear-gradient(${tpl.gradient_direction || '135deg'}, ${tpl.gradient_color1 || '#1a237e'}, ${tpl.gradient_color2 || '#4a148c'})`;
// //       } else if (tpl.gradient_type === 'radial') {
// //         style.background = `radial-gradient(circle at center, ${tpl.gradient_color1 || '#1a237e'}, ${tpl.gradient_color2 || '#4a148c'})`;
// //       }
// //     } else if (tpl.background_type === 'color') {
// //       style.backgroundColor = tpl.background_color || '#1a237e';
// //     } else {
// //       style.backgroundColor = 'transparent';
// //     }
    
// //     // Add overlay pattern if enabled
// //     if (tpl.overlay_enabled && tpl.overlay_pattern !== 'none') {
// //       const o = tpl.overlay_opacity || 0.1;
// //       if (tpl.overlay_pattern === 'dots') {
// //         style.backgroundImage = `radial-gradient(circle, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// //         style.backgroundSize = '20px 20px';
// //       } else if (tpl.overlay_pattern === 'lines') {
// //         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// //         style.backgroundSize = '20px 20px';
// //       } else if (tpl.overlay_pattern === 'grid') {
// //         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
// //         style.backgroundSize = '20px 20px';
// //       }
// //     }
    
// //     return style;
// //   };

// //   // Get signature image from template images
// //   const getSignatureImage = () => {
// //     if (!templateData?.images) return null;
// //     const sig = templateData.images.find(img => img.image_type === 'signature');
// //     return sig ? `${linkPath}/${sig.image_path}` : null;
// //   };

// //   // Get logo image from template images
// //   const getLogoImage = () => {
// //     if (!templateData?.images) return null;
// //     const logo = templateData.images.find(img => img.image_type === 'logo');
// //     return logo ? `${linkPath}/${logo.image_path}` : null;
// //   };

// //   // Get staff photo URL
// //   const getStaffPhoto = (staff) => {
// //     if (staff.image) return `${linkPath}/${staff.image}`;
// //     return `${linkPath}/empty_user.png`;
// //   };

// //   // Render single ID card
// //   const renderIDCard = (staff, forPrint = false) => {
// //     if (!templateData || !staff) return null;
    
// //     const bgStyle = getBackgroundStyle();
// //     const signatureImg = getSignatureImage();
// //     const logoImg = getLogoImage();
// //     const shadow = templateData.shadow_enabled 
// //       ? `0 20px 60px rgba(0,0,0,0.3), 0 10px 30px rgba(0,0,0,0.2)` 
// //       : 'none';
    
// //     return (
// //       <div
// //         key={staff.id}
// //         style={{
// //           width: cardSize.width,
// //           height: cardSize.height,
// //           ...bgStyle,
// //           borderRadius: templateData.border_radius || 16,
// //           boxShadow: shadow,
// //           position: 'relative',
// //           overflow: 'hidden',
// //           border: templateData.background_type === 'none' ? '2px dashed #d9d9d9' : '1px solid rgba(255,255,255,0.2)',
// //           margin: '0 auto',
// //           flexShrink: 0,
// //         }}
// //       >
// //         {/* Decorative circles */}
// //         {templateData.background_type !== 'none' && (
// //           <>
// //             <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
// //             <div style={{ position: 'absolute', bottom: -90, left: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
// //           </>
// //         )}
        
// //         {/* Chip */}
// //         {templateData.chip_enabled && (
// //           <div style={{ 
// //             position: 'absolute', top: 20, left: 20, width: 45, height: 32, 
// //             borderRadius: 6, 
// //             background: `linear-gradient(135deg, ${templateData.chip_color || '#FFD700'}, ${templateData.chip_color || '#FFD700'}cc)`, 
// //             boxShadow: '0 2px 8px rgba(0,0,0,0.2)', zIndex: 2 
// //           }}>
// //             <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
// //               <div style={{ width: 22, height: 16, borderRadius: 3, background: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.5)' }} />
// //             </div>
// //           </div>
// //         )}
        
// //         {/* Render elements */}
// //         {templateData.elements?.filter(el => el.is_visible !== 0).map((el, i) => (
// //           <div
// //             key={el.id || i}
// //             style={{
// //               position: 'absolute',
// //               left: el.x_position || 0,
// //               top: el.y_position || 0,
// //               width: el.width || 100,
// //               height: el.height || 30,
// //               display: 'flex',
// //               alignItems: 'center',
// //               justifyContent: el.text_align === 'center' ? 'center' : el.text_align === 'right' ? 'flex-end' : 'flex-start',
// //               fontSize: el.font_size || 12,
// //               color: el.font_color || '#FFF',
// //               fontWeight: el.font_weight || 'normal',
// //               fontFamily: el.font_family || 'Content, sans-serif',
// //               zIndex: el.element_key === 'photo' ? 3 : 2,
// //               overflow: 'hidden',
// //               textShadow: el.element_type === 'text' ? '0 1px 3px rgba(0,0,0,0.3)' : 'none',
// //             }}
// //           >
// //             {el.element_type === 'qrcode' ? (
// //               <div style={{ width: '100%', height: '100%', background: 'white', borderRadius: 4, padding: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
// //                 <img 
// //                   src={generateQRCode(staff.qrcode_intergrate_id || staff.idnumber || 'N/A', Math.min(el.width, el.height))} 
// //                   alt="QR" 
// //                   style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
// //                 />
// //               </div>
// //             ) : el.element_type === 'image' ? (
// //               <div style={{ 
// //                 width: '100%', height: '100%', 
// //                 borderRadius: el.element_key === 'photo' ? 8 : 0, 
// //                 border: el.element_key === 'photo' ? '2px solid rgba(255,255,255,0.3)' : 'none',
// //                 boxShadow: el.element_key === 'photo' ? '0 4px 12px rgba(0,0,0,0.2)' : 'none',
// //                 overflow: 'hidden', 
// //                 display: 'flex', 
// //                 alignItems: 'center', 
// //                 justifyContent: 'center' 
// //               }}>
// //                 {el.element_key === 'photo' ? (
// //                   <img src={getStaffPhoto(staff)} alt={staff.fullname} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
// //                 ) : el.element_key === 'signature' ? (
// //                   signatureImg ? <img src={signatureImg} alt="Signature" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : 
// //                   <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }}>✍️</span>
// //                 ) : el.element_key === 'org_logo' ? (
// //                   logoImg ? <img src={logoImg} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : 
// //                   <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }}>🏢</span>
// //                 ) : (
// //                   <PictureOutlined style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }} />
// //                 )}
// //               </div>
// //             ) : (
// //               <span style={{ padding: '2px 6px', borderRadius: 3, whiteSpace: 'nowrap' }}>
// //                 {el.element_type === 'custom-text' ? (el.custom_text || '') : getElementValue(el, staff)}
// //               </span>
// //             )}
// //           </div>
// //         ))}
// //       </div>
// //     );
// //   };

// //   const printAllCards = useReactToPrint({
// //   content: () => printRef.current,
// //   documentTitle: 'Staff_ID_Cards',
// //   pageStyle: `
// //     @page { 
// //       size: A4 portrait; 
// //       margin: 0; 
// //     }
// //     @media print {
// //       body { 
// //         margin: 0; 
// //         padding: 0;
// //         -webkit-print-color-adjust: exact !important;
// //         print-color-adjust: exact !important;
// //       }
// //       * {
// //         -webkit-print-color-adjust: exact !important;
// //         print-color-adjust: exact !important;
// //       }
// //       .print-page {
// //         width: 210mm !important;
// //         height: 297mm !important;
// //         page-break-after: always;
// //         break-after: page;
// //         padding: 8mm !important;
// //         box-sizing: border-box !important;
// //       }
// //       .print-page:last-child {
// //         page-break-after: auto;
// //         break-after: auto;
// //       }
// //     }
// //   `,
// //   copyStyles: true,
// //   onAfterPrint: () => message.success("បោះពុម្ពរួចរាល់!"),
// // });

// //   // Print single card
// //   const printSingleCard = useReactToPrint({
// //     content: () => singlePrintRef.current,
// //     documentTitle: 'Staff_ID_Card',
// //     onAfterPrint: () => message.success("បោះពុម្ពរួចរាល់!"),
// //   });

// //   if (!visible) return null;

// //   return (
// //     <>
// //       <Modal
// //         style={{  fontFamily: 'Content, sans-serif'}}
// //         title={
// //           <Space>
// //             <IdcardOutlined style={{ color: '#667eea' }} />
// //             <span>បញ្ជីកាតបុគ្គលិក ({savedStaffList?.length || 0} នាក់)</span>
// //           </Space>
// //         }
// //         open={visible}
// //         onCancel={onClose}
// //         width={1100}
// //         footer={[
// //           <Space key="footer" wrap>
// //             <Button danger onClick={onClear} icon={<DeleteOutlined />}>
// //               សម្អាតទាំងអស់
// //             </Button>
// //             <Button onClick={onClose}>បិទ</Button>
// //             <Button 
// //               type="primary" 
// //               icon={<PrinterOutlined />} 
// //               onClick={() => printAllCards()} 
// //               loading={loading}
// //               disabled={!templateData}
// //             >
// //               ព្រីនទាំងអស់ ({savedStaffList?.length || 0})
// //             </Button>
// //           </Space>
// //         ]}
// //         bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px', background: '#f5f5f5' }}
// //       >
// //         {/* Template Selector */}
// //         <div style={{ 
// //           marginBottom: '20px', 
// //           padding: '16px', 
// //           background: 'white', 
// //           borderRadius: '12px',
// //           boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
// //           display: 'flex',
// //           alignItems: 'center',
// //           gap: '16px',
// //           flexWrap: 'wrap'
// //         }}>
// //           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
// //             <IdcardOutlined style={{ color: '#667eea', fontSize: '18px' }} />
// //             <span style={{ fontWeight: 'bold', color: '#333', fontSize: '14px' }}>ជ្រើសរើសពុម្ពកាត:</span>
// //           </div>
// //           <Select
// //             style={{ minWidth: '250px' }}
// //             value={selectedTemplateId}
// //             onChange={(value) => setSelectedTemplateId(value)}
// //             size="large"
// //             placeholder="Select a template"
// //           >
// //             {templates.map(tpl => (
// //               <Option key={tpl.id} value={tpl.id}>
// //                 <Space>
// //                   {tpl.is_default === 1 && '⭐ '}
// //                   {tpl.template_name}
// //                   {tpl.is_default === 1 && (
// //                     <Tag color="gold" style={{ fontSize: '10px' }}>Default</Tag>
// //                   )}
// //                 </Space>
// //               </Option>
// //             ))}
// //           </Select>
// //           {templateData && (
// //             <Tag color="blue" style={{ fontSize: '12px' }}>
// //               {templateData.width} × {templateData.height} px | {templateData.orientation || 'landscape'}
// //             </Tag>
// //           )}
// //         </div>

// //         {/* Content */}
// //         {loading ? (
// //           <div style={{ textAlign: 'center', padding: '60px' }}>
// //             <Spin size="large" />
// //             <p style={{ marginTop: 16, color: '#666' }}>កំពុងផ្ទុកពុម្ពកាត...</p>
// //           </div>
// //         ) : !templateData ? (
// //           <div style={{ textAlign: 'center', padding: '60px' }}>
// //             <Empty description={
// //               <span>
// //                 មិនមានពុម្ពកាត!
// //                 <br />
// //                 សូមបង្កើតពុម្ពកាតនៅក្នុង <strong>ID Card Designer</strong>
// //               </span>
// //             } />
// //           </div>
// //         ) : savedStaffList?.length === 0 ? (
// //           <div style={{ textAlign: 'center', padding: '60px' }}>
// //             <Empty description="មិនមានបុគ្គលិកក្នុងបញ្ជី" />
// //           </div>
// //         ) : (
// //           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', justifyContent: 'center' }}>
// //             {savedStaffList.map((staff, index) => (
// //               <div key={staff.id} style={{ 
// //                 background: 'white', 
// //                 borderRadius: '16px', 
// //                 padding: '16px',
// //                 boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
// //                 transition: 'all 0.3s ease',
// //               }}
// //                 onMouseEnter={(e) => {
// //                   e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.15)';
// //                   e.currentTarget.style.transform = 'translateY(-4px)';
// //                 }}
// //                 onMouseLeave={(e) => {
// //                   e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
// //                   e.currentTarget.style.transform = 'translateY(0)';
// //                 }}
// //               >
// //                 {/* Card thumbnail */}
// //                 <div
// //                   onClick={() => { setSelectedStaff(staff); setPreviewVisible(true); }}
// //                   style={{
// //                     cursor: 'pointer',
// //                     borderRadius: '8px',
// //                     overflow: 'hidden',
// //                     marginBottom: '12px',
// //                   }}
// //                 >
// //                   <div style={{
// //                     transform: `scale(${Math.min(300 / cardSize.width, 200 / cardSize.height)})`,
// //                     transformOrigin: 'top left',
// //                     width: cardSize.width,
// //                     height: cardSize.height,
// //                     marginBottom: -(cardSize.height * (1 - Math.min(300 / cardSize.width, 200 / cardSize.height))),
// //                     marginRight: -(cardSize.width * (1 - Math.min(300 / cardSize.width, 200 / cardSize.height))),
// //                   }}>
// //                     {renderIDCard(staff)}
// //                   </div>
// //                 </div>
                
// //                 {/* Staff info */}
// //                 <div style={{ textAlign: 'center',fontFamily: 'Content, sans-serif' }}>
// //                   <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#1e8449', marginBottom: '4px' }}>
// //                     {staff.fullname}
// //                   </div>
                  
// //                   <div style={{ fontSize: '11px', color: '#aaa', marginBottom: '8px' }}>
// //                     {staff.department_name} | {staff.position_name}
// //                   </div>
// //                   <Space size="small">
// //                     <Tooltip title="មើលកាត">
// //                       <Button 
// //                         size="small" 
// //                         icon={<EyeOutlined />} 
// //                         onClick={() => { setSelectedStaff(staff); setPreviewVisible(true); }}
// //                         style={{ borderRadius: '8px' }}
// //                       />
// //                     </Tooltip>
// //                     <Tooltip title="ព្រីនកាត">
// //                       <Button 
// //                         size="small" 
// //                         type="primary" 
// //                         icon={<PrinterOutlined />} 
// //                         onClick={() => { setSelectedStaff(staff); setTimeout(() => printSingleCard(), 300); }}
// //                         style={{ borderRadius: '8px' }}
// //                       />
// //                     </Tooltip>
// //                     <Tooltip title="ដកចេញ">
// //                       <Button 
// //                         size="small" 
// //                         danger 
// //                         icon={<DeleteOutlined />} 
// //                         onClick={() => onRemove(staff.id)}
// //                         style={{ borderRadius: '8px' }}
// //                       />
// //                     </Tooltip>
// //                   </Space>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         )}
// //       </Modal>

// //       {/* Single Card Preview Modal */}
// //       <Modal
// //         title={
// //           <Space>
// //             <EyeOutlined />
// //             {selectedStaff?.fullname} - {selectedStaff?.idnumber}
// //           </Space>
// //         }
// //         open={previewVisible}
// //         onCancel={() => setPreviewVisible(false)}
// //         footer={[
// //           <Space key="footer">
// //             <Button onClick={() => setPreviewVisible(false)}>បិទ</Button>
// //             <Button type="primary" icon={<PrinterOutlined />} onClick={() => printSingleCard()}>
// //               ព្រីនកាតនេះ
// //             </Button>
// //           </Space>
// //         ]}
// //         width={cardSize.width + 100}
// //         bodyStyle={{ display: 'flex', justifyContent: 'center', padding: '30px', background: '#f0f2f5' }}
// //       >
// //         {selectedStaff && renderIDCard(selectedStaff)}
// //       </Modal>

// //       {/* Hidden print container for all cards — 6 per A4 page (2×3) */}
  
// // <div style={{ display: 'none' }}>
// //   <div ref={printRef} className="print-all-container">
// //     {savedStaffList && (() => {
// //       const pad = 30, gap = 19;
// //       const a4W = 794, a4H = 1123;
// //       const cellW = (a4W - pad * 2 - gap) / 2;
// //       const cellH = (a4H - pad * 2 - gap * 2) / 3;
// //       const scale = Math.min(cellW / cardSize.width, cellH / cardSize.height);
// //       const scaledW = Math.floor(cardSize.width * scale);
// //       const scaledH = Math.floor(cardSize.height * scale);

// //       const pages = [];
// //       const totalPages = Math.ceil(savedStaffList.length / 6);
      
// //       for (let i = 0; i < savedStaffList.length; i += 6) {
// //         const group = savedStaffList.slice(i, i + 6);
// //         const isLastPage = i + 6 >= savedStaffList.length;
        
// //         pages.push(
// //           <div
// //             key={i}
// //             className="print-page"
// //             style={{
// //               width: `${a4W}px`,
// //               height: `${a4H}px`,
// //               padding: `${pad}px`,
// //               boxSizing: 'border-box',
// //               display: 'grid',
// //               gridTemplateColumns: `${scaledW}px ${scaledW}px`,
// //               gridTemplateRows: `repeat(3, ${scaledH}px)`,
// //               gap: `${gap}px`,
// //               justifyContent: 'center',
// //               alignContent: 'center',
// //               backgroundColor: 'white',
// //               overflow: 'hidden',
// //               pageBreakAfter: isLastPage ? 'auto' : 'always',
// //               breakAfter: isLastPage ? 'auto' : 'page',
// //             }}
// //           >
// //             {group.map(staff => (
// //               <div
// //                 key={staff.id}
// //                 style={{
// //                   width: `${scaledW}px`,
// //                   height: `${scaledH}px`,
// //                   overflow: 'hidden',
// //                   flexShrink: 0,
// //                 }}
// //               >
// //                 <div style={{ 
// //                   zoom: scale, 
// //                   width: `${cardSize.width}px`, 
// //                   height: `${cardSize.height}px`,
// //                   WebkitPrintColorAdjust: 'exact',
// //                   printColorAdjust: 'exact',
// //                 }}>
// //                   {renderIDCard(staff, true)}
// //                 </div>
// //               </div>
// //             ))}
// //             {/* Fill empty slots if less than 6 cards on last page */}
// //             {isLastPage && group.length < 6 && 
// //               Array.from({ length: 6 - group.length }).map((_, idx) => (
// //                 <div
// //                   key={`empty-${idx}`}
// //                   style={{
// //                     width: `${scaledW}px`,
// //                     height: `${scaledH}px`,
// //                     border: '1px dashed #e0e0e0',
// //                     borderRadius: '8px',
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     justifyContent: 'center',
// //                     color: '#ccc',
// //                   }}
// //                 >
// //                   <PictureOutlined style={{ fontSize: '32px' }} />
// //                 </div>
// //               ))
// //             }
// //           </div>
// //         );
// //       }
// //       return pages;
// //     })()}
// //   </div>
// // </div>

// //       {/* Hidden print container for single card */}
// //       <div style={{ display: 'none' }}>
// //         <div ref={singlePrintRef}>
// //           {selectedStaff && renderIDCard(selectedStaff, true)}
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default SavedCardsPreview;

// // SavedCardsPreview.js - With Template Selection
// import React, { useState, useEffect, useRef } from "react";
// import {
//   Modal, Button, Space, Spin, Empty, message, Card as AntCard, 
//   Avatar, Tag, Tooltip, Select, Tabs, Badge
// } from "antd";
// import {
//   DownloadOutlined, EyeOutlined, DeleteOutlined, 
//   IdcardOutlined, CloseOutlined, PrinterOutlined,
//   UserOutlined, PhoneOutlined, BankOutlined, TeamOutlined,
//   GlobalOutlined, CrownOutlined, StarOutlined,
//   QrcodeOutlined, CameraOutlined, CheckCircleOutlined,
//   SwapOutlined, PictureOutlined
// } from "@ant-design/icons";
// import { request } from "../../../share/request";
// import { linkPath, linkPathIDCardDetail } from "../../../share/helper";
// import { getCurrentUser } from "../../../share/getProfile";
// import { useReactToPrint } from "react-to-print";
// import "./SavedCardsPreview.css";

// const { Option } = Select;

// const SavedCardsPreview = ({ visible, onClose, savedStaffList, onRemove, onClear }) => {
//   const getProfile = getCurrentUser();
//   const [loading, setLoading] = useState(false);
//   const [templates, setTemplates] = useState([]);
//   const [selectedTemplateId, setSelectedTemplateId] = useState(null);
//   const [templateData, setTemplateData] = useState(null);
//   const [selectedStaff, setSelectedStaff] = useState(null);
//   const [previewVisible, setPreviewVisible] = useState(false);
//   const [cardSize, setCardSize] = useState({ width: 540, height: 340 });
//   const [activeTab, setActiveTab] = useState('cards');
//   const printRef = useRef(null);
//   const singlePrintRef = useRef(null);

//   // Load templates on mount
//   useEffect(() => {
//     if (visible) {
//       loadTemplates();
//     }
//   }, [visible]);

//   // Load template when selected changes
//   useEffect(() => {
//     if (selectedTemplateId) {
//       loadTemplateData(selectedTemplateId);
//     }
//   }, [selectedTemplateId]);

//   // Load all available templates
//   const loadTemplates = async () => {
//     setLoading(true);
//     try {
//       const param = new URLSearchParams({ org_code: getProfile.org_code });
//       const res = await request(`id-card-templates?${param.toString()}`, "get", {});
//       if (res?.success && res.data.length > 0) {
//         setTemplates(res.data);
        
//         // Select default template first, otherwise first template
//         const defaultTemplate = res.data.find(t => t.is_default === 1);
//         const templateToLoad = defaultTemplate || res.data[0];
        
//         if (!selectedTemplateId) {
//           setSelectedTemplateId(templateToLoad.id);
//         }
//       }
//     } catch (e) {
//       console.error("Error loading templates:", e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Load full template data with elements and images
//   const loadTemplateData = async (templateId) => {
//     setLoading(true);
//     try {
//       const res = await request(`id-card-templates/${templateId}`, "get", {});
//       if (res?.success) {
//         setTemplateData(res.data);
//         setCardSize({ 
//           width: res.data.width || 540, 
//           height: res.data.height || 340 
//         });
//       }
//     } catch (e) {
//       console.error("Error loading template data:", e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Get element value from staff data
//   const getElementValue = (element, staff) => {
//     const valueMap = {
//       'fullname': staff.fullname || '',
//       'frontname': staff.frontname || '',
//       'staffname_eng': staff.staffname_eng || '',
//       'idnumber': staff.idnumber || '',
//       'gender': staff.gender || '',
//       'dob': staff.dob ? formatDate(staff.dob) : '',
//       'position_name': staff.position_name || '',
//       'department_name': staff.department_name || '',
//       'skill_name': staff.skill_name || '',
//       'jobstatus': staff.jobstatus || '',
//       'stafftype': staff.stafftype || '',
//       'level': staff.level || '',
//       'joinwork': staff.joinwork ? formatDate(staff.joinwork) : '',
//       'username': staff.idnumber || staff.username || '',
//       'phone': staff.username || '',
//       'org_name': getProfile.org_name_kh || '',
//       'qrcode_id': staff.qrcode_intergrate_id || staff.idnumber || '',
//       'role_name': staff.role_name || '',
//       'custom_text': element.custom_text || '',
//     };
//     return valueMap[element.element_key] || element.label || '';
//   };

//   // Format date
//   const formatDate = (dateStr) => {
//     if (!dateStr) return '';
//     try {
//       const date = new Date(dateStr);
//       return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
//     } catch {
//       return dateStr;
//     }
//   };

//   // Generate QR code with link card URL
//   const generateQRCode = (text, size) => {
//     if (!text) return '';
//     // Generate QR code that links to the card detail page
//     // Using qrserver API to generate QR code image
//     return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}&margin=5`;
//   };

//   // Get link card URL for staff
//   const getLinkCardURL = (staff) => {
//     if (!staff) return '';
//     const staffId = staff.qrcode_intergrate_id || staff.idnumber || staff.id;
//     return `${linkPathIDCardDetail}${staffId}`;
//   };
//   // Get background style from template
//   const getBackgroundStyle = () => {
//     if (!templateData) return { backgroundColor: '#1a237e' };
//     const tpl = templateData;
//     let style = {};
    
//     if (tpl.background_type === 'image' && tpl.background_image) {
//       style.backgroundImage = `url(${linkPath}/${tpl.background_image})`;
//       style.backgroundSize = tpl.bg_image_size === 'stretch' ? '100% 100%' : (tpl.bg_image_size || 'cover');
//       style.backgroundPosition = tpl.bg_image_position || 'center';
//       style.backgroundRepeat = 'no-repeat';
//       if (tpl.bg_image_opacity && tpl.bg_image_opacity < 1) {
//         style.opacity = tpl.bg_image_opacity;
//       }
//     } else if (tpl.background_type === 'gradient') {
//       if (tpl.gradient_type === 'linear') {
//         style.background = `linear-gradient(${tpl.gradient_direction || '135deg'}, ${tpl.gradient_color1 || '#1a237e'}, ${tpl.gradient_color2 || '#4a148c'})`;
//       } else if (tpl.gradient_type === 'radial') {
//         style.background = `radial-gradient(circle at center, ${tpl.gradient_color1 || '#1a237e'}, ${tpl.gradient_color2 || '#4a148c'})`;
//       }
//     } else if (tpl.background_type === 'color') {
//       style.backgroundColor = tpl.background_color || '#1a237e';
//     } else {
//       style.backgroundColor = 'transparent';
//     }
    
//     // Add overlay pattern if enabled
//     if (tpl.overlay_enabled && tpl.overlay_pattern !== 'none') {
//       const o = tpl.overlay_opacity || 0.1;
//       if (tpl.overlay_pattern === 'dots') {
//         style.backgroundImage = `radial-gradient(circle, rgba(255,255,255,${o}) 1px, transparent 1px)`;
//         style.backgroundSize = '20px 20px';
//       } else if (tpl.overlay_pattern === 'lines') {
//         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
//         style.backgroundSize = '20px 20px';
//       } else if (tpl.overlay_pattern === 'grid') {
//         style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
//         style.backgroundSize = '20px 20px';
//       }
//     }
    
//     return style;
//   };

//   // Get signature image from template images
//   const getSignatureImage = () => {
//     if (!templateData?.images) return null;
//     const sig = templateData.images.find(img => img.image_type === 'signature');
//     return sig ? `${linkPath}/${sig.image_path}` : null;
//   };

//   // Get logo image from template images
//   const getLogoImage = () => {
//     if (!templateData?.images) return null;
//     const logo = templateData.images.find(img => img.image_type === 'logo');
//     return logo ? `${linkPath}/${logo.image_path}` : null;
//   };

//   // Get staff photo URL
//   const getStaffPhoto = (staff) => {
//     if (staff.image) return `${linkPath}/${staff.image}`;
//     return `${linkPath}/empty_user.png`;
//   };

//   // Render single ID card
//   const renderIDCard = (staff, forPrint = false) => {
//     if (!templateData || !staff) return null;
    
//     const bgStyle = getBackgroundStyle();
//     const signatureImg = getSignatureImage();
//     const logoImg = getLogoImage();
//     const shadow = templateData.shadow_enabled 
//       ? `0 20px 60px rgba(0,0,0,0.3), 0 10px 30px rgba(0,0,0,0.2)` 
//       : 'none';
//      // Get link card URL for QR code
//     const linkCardURL = getLinkCardURL(staff);
    
//     return (
//       <div
//         key={staff.id}
//         style={{
//           width: cardSize.width,
//           height: cardSize.height,
//           ...bgStyle,
//           borderRadius: templateData.border_radius || 16,
//           boxShadow: shadow,
//           position: 'relative',
//           overflow: 'hidden',
//           border: templateData.background_type === 'none' ? '2px dashed #d9d9d9' : '1px solid rgba(255,255,255,0.2)',
//           margin: '0 auto',
//           flexShrink: 0,
//         }}
//       >
//         {/* Decorative circles */}
//         {templateData.background_type !== 'none' && (
//           <>
//             <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
//             <div style={{ position: 'absolute', bottom: -90, left: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
//           </>
//         )}
        
//         {/* Chip */}
//         {!!templateData.chip_enabled && (
//           <div style={{ 
//             position: 'absolute', top: 20, left: 20, width: 45, height: 32, 
//             borderRadius: 6, 
//             background: `linear-gradient(135deg, ${templateData.chip_color || '#FFD700'}, ${templateData.chip_color || '#FFD700'}cc)`, 
//             boxShadow: '0 2px 8px rgba(0,0,0,0.2)', zIndex: 2 
//           }}>
//             <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//               <div style={{ width: 22, height: 16, borderRadius: 3, background: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.5)' }} />
//             </div>
//           </div>
//         )}
        
//         {/* Render elements */}
//         {templateData.elements?.filter(el => el.is_visible !== 0).map((el, i) => (
//           <div
//             key={el.id || i}
//             style={{
//               position: 'absolute',
//               left: el.x_position || 0,
//               top: el.y_position || 0,
//               width: el.width || 100,
//               height: el.height || 30,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: el.text_align === 'center' ? 'center' : el.text_align === 'right' ? 'flex-end' : 'flex-start',
//               fontSize: el.font_size || 12,
//               color: el.font_color || '#FFF',
//               fontWeight: el.font_weight || 'normal',
//               fontFamily: el.font_family || 'Content, sans-serif',
//               zIndex: el.element_key === 'photo' ? 3 : 2,
//               overflow: 'hidden',
//               textShadow: el.element_type === 'text' ? '0 1px 3px rgba(0,0,0,0.3)' : 'none',
//             }}
//           >
//             {el.element_type === 'qrcode' ? (
//   <div style={{ 
//     width: '100%', 
//     height: '100%', 
//     background: 'white', 
//     borderRadius: 4, 
//     padding: 4, 
//     display: 'flex', 
//     alignItems: 'center', 
//     justifyContent: 'center',
//     position: 'relative'
//   }}>
//     <img 
//       src={generateQRCode(linkCardURL, Math.min(el.width, el.height))} 
//       alt="QR Code" 
//       style={{ width: '100%', height: '100%', objectFit: 'contain' }}
//       title={`Link: ${linkCardURL}`}
//     />
    
//     {/* Verify Badge in bottom-right corner - won't block QR center */}
//     <div style={{
//       position: 'absolute',
//       bottom: '6px',
//       right: '6px',
//       width: '18px',
//       height: '18px',
//       borderRadius: '50%',
//       background: 'linear-gradient(135deg, #4CAF50, #45a049)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       boxShadow: '0 1px 4px rgba(0,0,0,0.2), 0 0 0 2px rgba(255,255,255,0.9)',
//       zIndex: 5,
//     }}>
//       <CheckCircleOutlined style={{ 
//         fontSize: '10px', 
//         color: 'white',
//       }} />
//     </div>
//   </div>
// ) : el.element_type === 'image' ? (
//               <div style={{ 
//                 width: '100%', height: '100%', 
//                 borderRadius: el.element_key === 'photo' ? 8 : 0, 
//                 border: el.element_key === 'photo' ? '2px solid rgba(255,255,255,0.3)' : 'none',
//                 boxShadow: el.element_key === 'photo' ? '0 4px 12px rgba(0,0,0,0.2)' : 'none',
//                 overflow: 'hidden', 
//                 display: 'flex', 
//                 alignItems: 'center', 
//                 justifyContent: 'center' 
//               }}>
//                 {el.element_key === 'photo' ? (
//                   <img src={getStaffPhoto(staff)} alt={staff.fullname} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                 ) : el.element_key === 'signature' ? (
//                   signatureImg ? <img src={signatureImg} alt="Signature" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : 
//                   <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }}>✍️</span>
//                 ) : el.element_key === 'org_logo' ? (
//                   logoImg ? <img src={logoImg} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : 
//                   <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }}>🏢</span>
//                 ) : (
//                   <PictureOutlined style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }} />
//                 )}
//               </div>
//             ) : (
//               <span style={{ padding: '2px 6px', borderRadius: 3, whiteSpace: 'nowrap' }}>
//                 {el.element_type === 'custom-text' ? (el.custom_text || '') : getElementValue(el, staff)}
//               </span>
//             )}
//           </div>
//         ))}
//       </div>
//     );
//   };

//   const printAllCards = useReactToPrint({
//   content: () => printRef.current,
//   documentTitle: 'Staff_ID_Cards',
//   pageStyle: `
//     @page { 
//       size: A4 portrait; 
//       margin: 0; 
//     }
//     @media print {
//       body { 
//         margin: 0; 
//         padding: 0;
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//       * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//       .print-page {
//         width: 210mm !important;
//         height: 297mm !important;
//         page-break-after: always;
//         break-after: page;
//         padding: 8mm !important;
//         box-sizing: border-box !important;
//       }
//       .print-page:last-child {
//         page-break-after: auto;
//         break-after: auto;
//       }
//     }
//   `,
//   copyStyles: true,
//   onAfterPrint: () => message.success("បោះពុម្ពរួចរាល់!"),
// });

//   // Print single card
//   const printSingleCard = useReactToPrint({
//     content: () => singlePrintRef.current,
//     documentTitle: 'Staff_ID_Card',
//     onAfterPrint: () => message.success("បោះពុម្ពរួចរាល់!"),
//   });

//   if (!visible) return null;

//   return (
//     <>
//       <Modal
//         style={{  fontFamily: 'Content, sans-serif'}}
//         title={
//           <Space>
//             <IdcardOutlined style={{ color: '#667eea' }} />
//             <span>បញ្ជីកាតបុគ្គលិក ({savedStaffList?.length || 0} នាក់)</span>
//           </Space>
//         }
//         open={visible}
//         onCancel={onClose}
//         width={1100}
//         footer={[
//           <Space key="footer" wrap>
//             <Button danger onClick={onClear} icon={<DeleteOutlined />}>
//               សម្អាតទាំងអស់
//             </Button>
//             <Button onClick={onClose}>បិទ</Button>
//             <Button 
//               type="primary" 
//               icon={<PrinterOutlined />} 
//               onClick={() => printAllCards()} 
//               loading={loading}
//               disabled={!templateData}
//             >
//               ព្រីនទាំងអស់ ({savedStaffList?.length || 0})
//             </Button>
//           </Space>
//         ]}
//         bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px', background: '#f5f5f5' }}
//       >
//         {/* Template Selector */}
//         <div style={{ 
//           marginBottom: '20px', 
//           padding: '16px', 
//           background: 'white', 
//           borderRadius: '12px',
//           boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//           display: 'flex',
//           alignItems: 'center',
//           gap: '16px',
//           flexWrap: 'wrap'
//         }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//             <IdcardOutlined style={{ color: '#667eea', fontSize: '18px' }} />
//             <span style={{ fontWeight: 'bold', color: '#333', fontSize: '14px' }}>ជ្រើសរើសពុម្ពកាត:</span>
//           </div>
//           <Select
//             style={{ minWidth: '250px' }}
//             value={selectedTemplateId}
//             onChange={(value) => setSelectedTemplateId(value)}
//             size="large"
//             placeholder="Select a template"
//           >
//             {templates.map(tpl => (
//               <Option key={tpl.id} value={tpl.id}>
//                 <Space>
//                   {tpl.is_default === 1 && '⭐ '}
//                   {tpl.template_name}
//                   {tpl.is_default === 1 && (
//                     <Tag color="gold" style={{ fontSize: '10px' }}>Default</Tag>
//                   )}
//                 </Space>
//               </Option>
//             ))}
//           </Select>
//           {templateData && (
//             <Tag color="blue" style={{ fontSize: '12px' }}>
//               {templateData.width} × {templateData.height} px | {templateData.orientation || 'landscape'}
//             </Tag>
//           )}
//         </div>

//         {/* Content */}
//         {loading ? (
//           <div style={{ textAlign: 'center', padding: '60px' }}>
//             <Spin size="large" />
//             <p style={{ marginTop: 16, color: '#666' }}>កំពុងផ្ទុកពុម្ពកាត...</p>
//           </div>
//         ) : !templateData ? (
//           <div style={{ textAlign: 'center', padding: '60px' }}>
//             <Empty description={
//               <span>
//                 មិនមានពុម្ពកាត!
//                 <br />
//                 សូមបង្កើតពុម្ពកាតនៅក្នុង <strong>ID Card Designer</strong>
//               </span>
//             } />
//           </div>
//         ) : savedStaffList?.length === 0 ? (
//           <div style={{ textAlign: 'center', padding: '60px' }}>
//             <Empty description="មិនមានបុគ្គលិកក្នុងបញ្ជី" />
//           </div>
//         ) : (
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', justifyContent: 'center' }}>
//             {savedStaffList.map((staff, index) => (
//               <div key={staff.id} style={{ 
//                 background: 'white', 
//                 borderRadius: '16px', 
//                 padding: '16px',
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//                 transition: 'all 0.3s ease',
//               }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.15)';
//                   e.currentTarget.style.transform = 'translateY(-4px)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
//                   e.currentTarget.style.transform = 'translateY(0)';
//                 }}
//               >
//                 {/* Card thumbnail */}
//                 <div
//                   onClick={() => { setSelectedStaff(staff); setPreviewVisible(true); }}
//                   style={{
//                     cursor: 'pointer',
//                     borderRadius: '8px',
//                     overflow: 'hidden',
//                     marginBottom: '12px',
//                   }}
//                 >
//                   <div style={{
//                     transform: `scale(${Math.min(300 / cardSize.width, 200 / cardSize.height)})`,
//                     transformOrigin: 'top left',
//                     width: cardSize.width,
//                     height: cardSize.height,
//                     marginBottom: -(cardSize.height * (1 - Math.min(300 / cardSize.width, 200 / cardSize.height))),
//                     marginRight: -(cardSize.width * (1 - Math.min(300 / cardSize.width, 200 / cardSize.height))),
//                   }}>
//                     {renderIDCard(staff)}
//                   </div>
//                 </div>
                
//                 {/* Staff info */}
//                 <div style={{ textAlign: 'center',fontFamily: 'Content, sans-serif' }}>
//                   <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#1e8449', marginBottom: '4px' }}>
//                     {staff.fullname}
//                   </div>
                  
//                   <div style={{ fontSize: '11px', color: '#aaa', marginBottom: '8px' }}>
//                     {staff.department_name} | {staff.position_name}
//                   </div>
//                   <Space size="small">
//                     <Tooltip title="មើលកាត">
//                       <Button 
//                         size="small" 
//                         icon={<EyeOutlined />} 
//                         onClick={() => { setSelectedStaff(staff); setPreviewVisible(true); }}
//                         style={{ borderRadius: '8px' }}
//                       />
//                     </Tooltip>
//                     <Tooltip title="ព្រីនកាត">
//                       <Button 
//                         size="small" 
//                         type="primary" 
//                         icon={<PrinterOutlined />} 
//                         onClick={() => { setSelectedStaff(staff); setTimeout(() => printSingleCard(), 300); }}
//                         style={{ borderRadius: '8px' }}
//                       />
//                     </Tooltip>
//                     <Tooltip title="ដកចេញ">
//                       <Button 
//                         size="small" 
//                         danger 
//                         icon={<DeleteOutlined />} 
//                         onClick={() => onRemove(staff.id)}
//                         style={{ borderRadius: '8px' }}
//                       />
//                     </Tooltip>
//                   </Space>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </Modal>

//       {/* Single Card Preview Modal */}
//       <Modal
//         title={
//           <Space>
//             <EyeOutlined />
//             {selectedStaff?.fullname} - {selectedStaff?.idnumber}
//           </Space>
//         }
//         open={previewVisible}
//         onCancel={() => setPreviewVisible(false)}
//         footer={[
//           <Space key="footer">
//             <Button onClick={() => setPreviewVisible(false)}>បិទ</Button>
//             <Button type="primary" icon={<PrinterOutlined />} onClick={() => printSingleCard()}>
//               ព្រីនកាតនេះ
//             </Button>
//           </Space>
//         ]}
//         width={cardSize.width + 100}
//         bodyStyle={{ display: 'flex', justifyContent: 'center', padding: '30px', background: '#f0f2f5' }}
//       >
//         {selectedStaff && renderIDCard(selectedStaff)}
//       </Modal>

//       {/* Hidden print container for all cards — 6 per A4 page (2×3) */}
  
// <div style={{ display: 'none' }}>
//   <div ref={printRef} className="print-all-container">
//     {savedStaffList && (() => {
//       const pad = 30, gap = 19;
//       const a4W = 794, a4H = 1123;
//       const cellW = (a4W - pad * 2 - gap) / 2;
//       const cellH = (a4H - pad * 2 - gap * 2) / 3;
//       const scale = Math.min(cellW / cardSize.width, cellH / cardSize.height);
//       const scaledW = Math.floor(cardSize.width * scale);
//       const scaledH = Math.floor(cardSize.height * scale);

//       const pages = [];
//       const totalPages = Math.ceil(savedStaffList.length / 6);
      
//       for (let i = 0; i < savedStaffList.length; i += 6) {
//         const group = savedStaffList.slice(i, i + 6);
//         const isLastPage = i + 6 >= savedStaffList.length;
        
//         pages.push(
//           <div
//             key={i}
//             className="print-page"
//             style={{
//               width: `${a4W}px`,
//               height: `${a4H}px`,
//               padding: `${pad}px`,
//               boxSizing: 'border-box',
//               display: 'grid',
//               gridTemplateColumns: `${scaledW}px ${scaledW}px`,
//               gridTemplateRows: `repeat(3, ${scaledH}px)`,
//               gap: `${gap}px`,
//               justifyContent: 'center',
//               alignContent: 'center',
//               backgroundColor: 'white',
//               overflow: 'hidden',
//               pageBreakAfter: isLastPage ? 'auto' : 'always',
//               breakAfter: isLastPage ? 'auto' : 'page',
//             }}
//           >
//             {group.map(staff => (
//               <div
//                 key={staff.id}
//                 style={{
//                   width: `${scaledW}px`,
//                   height: `${scaledH}px`,
//                   overflow: 'hidden',
//                   flexShrink: 0,
//                 }}
//               >
//                 <div style={{ 
//                   zoom: scale, 
//                   width: `${cardSize.width}px`, 
//                   height: `${cardSize.height}px`,
//                   WebkitPrintColorAdjust: 'exact',
//                   printColorAdjust: 'exact',
//                 }}>
//                   {renderIDCard(staff, true)}
//                 </div>
//               </div>
//             ))}
//             {/* Fill empty slots if less than 6 cards on last page */}
//             {isLastPage && group.length < 6 && 
//               Array.from({ length: 6 - group.length }).map((_, idx) => (
//                 <div
//                   key={`empty-${idx}`}
//                   style={{
//                     width: `${scaledW}px`,
//                     height: `${scaledH}px`,
//                     border: '1px dashed #e0e0e0',
//                     borderRadius: '8px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     color: '#ccc',
//                   }}
//                 >
//                   <PictureOutlined style={{ fontSize: '32px' }} />
//                 </div>
//               ))
//             }
//           </div>
//         );
//       }
//       return pages;
//     })()}
//   </div>
// </div>

//       {/* Hidden print container for single card */}
//       <div style={{ display: 'none' }}>
//         <div ref={singlePrintRef}>
//           {selectedStaff && renderIDCard(selectedStaff, true)}
//         </div>
//       </div>
//     </>
//   );
// };

// export default SavedCardsPreview;


// SavedCardsPreview.js - Full Update with Shapes, Custom Photos, QR Colors
import React, { useState, useEffect, useRef } from "react";
import {
  Modal, Button, Space, Spin, Empty, message, Tag, Tooltip, Select
} from "antd";
import {
  DownloadOutlined, EyeOutlined, DeleteOutlined, 
  IdcardOutlined, PrinterOutlined,
  UserOutlined, PhoneOutlined, BankOutlined, TeamOutlined,
  GlobalOutlined, CrownOutlined, StarOutlined,
  QrcodeOutlined, CameraOutlined, CheckCircleOutlined,
  PictureOutlined
} from "@ant-design/icons";
import { request } from "../../../share/request";
import { linkPath, linkPathIDCardDetail } from "../../../share/helper";
import { getCurrentUser } from "../../../share/getProfile";
import { useReactToPrint } from "react-to-print";
import "./SavedCardsPreview.css";

const { Option } = Select;

const SavedCardsPreview = ({ visible, onClose, savedStaffList, onRemove, onClear }) => {
  const getProfile = getCurrentUser();
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [templateData, setTemplateData] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [cardSize, setCardSize] = useState({ width: 540, height: 340 });
  const printRef = useRef(null);
  const singlePrintRef = useRef(null);

  // Load templates on mount
  useEffect(() => {
    if (visible) {
      loadTemplates();
    }
  }, [visible]);

  // Load template when selected changes
  useEffect(() => {
    if (selectedTemplateId) {
      loadTemplateData(selectedTemplateId);
    }
  }, [selectedTemplateId]);

  // Load all available templates
  const loadTemplates = async () => {
    setLoading(true);
    try {
      const param = new URLSearchParams({ org_code: getProfile.org_code });
      const res = await request(`id-card-templates?${param.toString()}`, "get", {});
      if (res?.success && res.data.length > 0) {
        setTemplates(res.data);
        const defaultTemplate = res.data.find(t => t.is_default === 1);
        const templateToLoad = defaultTemplate || res.data[0];
        if (!selectedTemplateId) {
          setSelectedTemplateId(templateToLoad.id);
        }
      }
    } catch (e) {
      console.error("Error loading templates:", e);
    } finally {
      setLoading(false);
    }
  };

  // Load full template data with elements and images
  const loadTemplateData = async (templateId) => {
    setLoading(true);
    try {
      const res = await request(`id-card-templates/${templateId}`, "get", {});
      if (res?.success) {
        setTemplateData(res.data);
        setCardSize({ 
          width: res.data.width || 540, 
          height: res.data.height || 340 
        });
      }
    } catch (e) {
      console.error("Error loading template data:", e);
    } finally {
      setLoading(false);
    }
  };

  // Get element value from staff data
  const getElementValue = (element, staff) => {
    const valueMap = {
      'fullname': staff.fullname || '',
      'frontname': staff.frontname || '',
      'staffname_eng': staff.staffname_eng || '',
      'idnumber': staff.idnumber || '',
      'gender': staff.gender || '',
      'dob': staff.dob ? formatDate(staff.dob) : '',
      'position_name': staff.position_name || '',
      'department_name': staff.department_name || '',
      'skill_name': staff.skill_name || '',
      'jobstatus': staff.jobstatus || '',
      'stafftype': staff.stafftype || '',
      'level': staff.level || '',
      'joinwork': staff.joinwork ? formatDate(staff.joinwork) : '',
      'username': staff.idnumber || staff.username || '',
      'phone': staff.username || '',
      'org_name': getProfile.org_name_kh || '',
      'qrcode_id': staff.qrcode_intergrate_id || staff.idnumber || '',
      'role_name': staff.role_name || '',
      'custom_text': element.custom_text || '',
    };
    return valueMap[element.element_key] || element.label || '';
  };

  // Format date
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
      return dateStr;
    }
  };

  // Generate QR code with link card URL
  const generateQRCode = (text, size, fgColor = '#000000', bgColor = '#FFFFFF') => {
    if (!text) return '';
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(text)}&margin=5&color=${fgColor.replace('#', '')}&bgcolor=${bgColor.replace('#', '')}`;
  };

  // Get link card URL for staff
  const getLinkCardURL = (staff) => {
    if (!staff) return '';
    const staffId = staff.qrcode_intergrate_id || staff.idnumber || staff.id;
    return `${linkPathIDCardDetail}${staffId}`;
  };

  // Get background style from template
  const getBackgroundStyle = () => {
    if (!templateData) return { backgroundColor: '#1a237e' };
    const tpl = templateData;
    let style = {};
    
    if (tpl.background_type === 'image' && tpl.background_image) {
      style.backgroundImage = `url(${linkPath}/${tpl.background_image})`;
      style.backgroundSize = tpl.bg_image_size === 'stretch' ? '100% 100%' : (tpl.bg_image_size || 'cover');
      style.backgroundPosition = tpl.bg_image_position || 'center';
      style.backgroundRepeat = 'no-repeat';
      if (tpl.bg_image_opacity && tpl.bg_image_opacity < 1) {
        style.opacity = tpl.bg_image_opacity;
      }
    } else if (tpl.background_type === 'gradient') {
      if (tpl.gradient_type === 'linear') {
        style.background = `linear-gradient(${tpl.gradient_direction || '135deg'}, ${tpl.gradient_color1 || '#1a237e'}, ${tpl.gradient_color2 || '#4a148c'})`;
      } else if (tpl.gradient_type === 'radial') {
        style.background = `radial-gradient(circle at center, ${tpl.gradient_color1 || '#1a237e'}, ${tpl.gradient_color2 || '#4a148c'})`;
      }
    } else if (tpl.background_type === 'color') {
      style.backgroundColor = tpl.background_color || '#1a237e';
    } else {
      style.backgroundColor = 'transparent';
    }
    
    if (tpl.overlay_enabled && tpl.overlay_pattern !== 'none') {
      const o = tpl.overlay_opacity || 0.1;
      if (tpl.overlay_pattern === 'dots') {
        style.backgroundImage = `radial-gradient(circle, rgba(255,255,255,${o}) 1px, transparent 1px)`;
        style.backgroundSize = '20px 20px';
      } else if (tpl.overlay_pattern === 'lines') {
        style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
        style.backgroundSize = '20px 20px';
      } else if (tpl.overlay_pattern === 'grid') {
        style.backgroundImage = `linear-gradient(90deg, rgba(255,255,255,${o}) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,${o}) 1px, transparent 1px)`;
        style.backgroundSize = '20px 20px';
      }
    }
    
    return style;
  };

  // Get image by type from template images
  const getTemplateImage = (imageType) => {
    if (!templateData?.images) return null;
    const img = templateData.images.find(i => i.image_type === imageType);
    return img ? `${linkPath}/${img.image_path}` : null;
  };

  // Get all custom photos from template images
  const getCustomPhotos = () => {
    if (!templateData?.images) return [];
    return templateData.images.filter(i => i.image_type === 'custom_photo');
  };

  // Get staff photo URL
  const getStaffPhoto = (staff) => {
    if (staff.image) return `${linkPath}/${staff.image}`;
    return `${linkPath}/empty_user.png`;
  };

  // Get shadow style for card
  const getCardShadow = () => {
    if (!templateData) return 'none';
    if (templateData.shadow_enabled) {
      const sx = templateData.shadow_x || 0;
      const sy = templateData.shadow_y || 10;
      const sb = templateData.shadow_blur || 20;
      const ss = templateData.shadow_spread || 0;
      const sc = templateData.shadow_color || 'rgba(0,0,0,0.3)';
      return `${sx}px ${sy}px ${sb}px ${ss}px ${sc}`;
    }
    return 'none';
  };

  // Get shape style
  const getShapeStyle = (el) => {
    let style = {
      width: '100%',
      height: '100%',
      opacity: el.shape_opacity !== undefined ? el.shape_opacity : 1,
    };

    if (el.shape_fill_type === 'gradient') {
      style.background = `linear-gradient(${el.shape_gradient_direction || '135deg'}, ${el.shape_gradient_color1 || '#667eea'}, ${el.shape_gradient_color2 || '#764ba2'})`;
    } else {
      style.backgroundColor = el.shape_fill_color || '#4CAF50';
    }

    if (el.shape_type === 'circle') {
      style.borderRadius = '50%';
    } else if (el.shape_type === 'rounded') {
      style.borderRadius = `${el.shape_border_radius || 8}px`;
    } else if (el.shape_type === 'rectangle') {
      style.borderRadius = '0';
    }

    if (el.shape_shadow_enabled) {
      style.boxShadow = `0 ${el.shape_shadow_blur || 10}px ${(el.shape_shadow_blur * 2) || 20}px ${el.shape_shadow_color || 'rgba(0,0,0,0.3)'}`;
    }

    if (el.shape_border_enabled) {
      style.border = `${el.shape_border_width || 1}px solid ${el.shape_border_color || '#ffffff'}`;
    }

    return style;
  };

  // Render single ID card
  const renderIDCard = (staff, forPrint = false) => {
    if (!templateData || !staff) return null;
    
    const bgStyle = getBackgroundStyle();
    const signatureImg = getTemplateImage('signature');
    const logoImg = getTemplateImage('logo');
    const customPhotos = getCustomPhotos();
    const shadow = getCardShadow();
    const linkCardURL = getLinkCardURL(staff);
    
    // Sort elements by z_index
    const sortedElements = (templateData.elements || [])
      .filter(el => el.is_visible !== 0)
      .sort((a, b) => (a.z_index || 2) - (b.z_index || 2));
    
    return (
      <div
        key={staff.id}
        style={{
          width: cardSize.width,
          height: cardSize.height,
          ...bgStyle,
          borderRadius: templateData.border_radius || 16,
          boxShadow: shadow,
          position: 'relative',
          overflow: 'hidden',
          border: templateData.background_type === 'none' ? '2px dashed #d9d9d9' : '1px solid rgba(255,255,255,0.2)',
          margin: '0 auto',
          flexShrink: 0,
        }}
      >
        {/* Decorative circles */}
        {templateData.background_type !== 'none' && (
          <>
            <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
            <div style={{ position: 'absolute', bottom: -90, left: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', pointerEvents: 'none' }} />
          </>
        )}
        
        {/* Chip */}
        {!!templateData.chip_enabled && (
          <div style={{ 
            position: 'absolute', top: 20, left: 20, width: 45, height: 32, 
            borderRadius: 6, 
            background: `linear-gradient(135deg, ${templateData.chip_color || '#FFD700'}, ${templateData.chip_color || '#FFD700'}cc)`, 
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)', zIndex: 2 
          }}>
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ width: 22, height: 16, borderRadius: 3, background: 'rgba(255,255,255,0.3)', border: '1px solid rgba(255,255,255,0.5)' }} />
            </div>
          </div>
        )}
        
        {/* Render elements sorted by z_index */}
        {sortedElements.map((el, i) => {
          // Get custom photo for this element if it has a custom_photo_index
          const customPhoto = el.element_key === 'custom_photo' && el.custom_photo_index !== null && el.custom_photo_index !== undefined
            ? customPhotos[el.custom_photo_index]
            : null;
          
          return (
            <div
              key={el.id || i}
              style={{
                position: 'absolute',
                left: el.x_position || 0,
                top: el.y_position || 0,
                width: el.width || 100,
                height: el.height || 30,
                display: 'flex',
                alignItems: 'center',
                justifyContent: el.text_align === 'center' ? 'center' : el.text_align === 'right' ? 'flex-end' : 'flex-start',
                fontSize: el.font_size || 12,
                color: el.font_color || '#FFF',
                fontWeight: el.font_weight || 'normal',
                fontFamily: el.font_family || 'Content, sans-serif',
                zIndex: el.z_index || 2,
                overflow: 'hidden',
                textShadow: (el.element_type === 'text' || el.element_type === 'custom-text') ? '0 1px 3px rgba(0,0,0,0.3)' : 'none',
                background: el.element_type === 'shape' ? 'transparent' : 'transparent',
                borderRadius: el.element_type === 'shape' ? 0 : 0,
                padding: el.element_type === 'shape' ? 0 : 0,
              }}
            >
              {/* SHAPE */}
              {el.element_type === 'shape' ? (
                <div style={getShapeStyle(el)}>
                  {el.label && el.label !== 'Shape' && (
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#fff',
                      fontSize: el.font_size || 12,
                      fontWeight: el.font_weight || 'bold',
                      textAlign: 'center',
                      width: '100%',
                      padding: '4px',
                      textShadow: '0 1px 3px rgba(0,0,0,0.3)',
                    }}>
                      {el.label}
                    </div>
                  )}
                </div>
              ) : el.element_type === 'qrcode' ? (
                /* QR CODE with custom colors */
                <div style={{ 
                  width: '100%', 
                  height: '100%', 
                  background: el.qr_bg_color || '#FFFFFF', 
                  borderRadius: 4, 
                  padding: 4, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  position: 'relative'
                }}>
                  <img 
                    src={generateQRCode(
                      linkCardURL, 
                      Math.min(el.width, el.height),
                      el.qr_fg_color || '#000000',
                      el.qr_bg_color || '#FFFFFF'
                    )} 
                    alt="QR Code" 
                    style={{ 
                      width: '100%', 
                      height: '100%', 
                      objectFit: 'contain',
                      borderRadius: el.qr_style === 'rounded' ? '8px' : '0',
                    }}
                    title={`Link: ${linkCardURL}`}
                  />
                  {/* Verify Badge */}
                  <div style={{
                    position: 'absolute',
                    bottom: '6px',
                    right: '6px',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #4CAF50, #45a049)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.2), 0 0 0 2px rgba(255,255,255,0.9)',
                    zIndex: 5,
                  }}>
                    <CheckCircleOutlined style={{ fontSize: '10px', color: 'white' }} />
                  </div>
                </div>
              ) : el.element_type === 'image' ? (
                /* IMAGE */
                <div style={{ 
                  width: '100%', 
                  height: '100%', 
                  borderRadius: el.element_key === 'photo' ? 8 : 0, 
                  border: el.element_key === 'photo' ? '2px solid rgba(255,255,255,0.3)' : 'none',
                  boxShadow: el.element_key === 'photo' ? '0 4px 12px rgba(0,0,0,0.2)' : 'none',
                  overflow: 'hidden', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
                }}>
                  {el.element_key === 'photo' ? (
                    <img src={getStaffPhoto(staff)} alt={staff.fullname} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : el.element_key === 'signature' ? (
                    signatureImg ? <img src={signatureImg} alt="Signature" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : 
                    <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }}>✍️</span>
                  ) : el.element_key === 'org_logo' ? (
                    logoImg ? <img src={logoImg} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : 
                    <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }}>🏢</span>
                  ) : el.element_key === 'custom_photo' ? (
                    customPhoto ? <img src={`${linkPath}/${customPhoto.image_path}`} alt="Custom" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> :
                    <PictureOutlined style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }} />
                  ) : (
                    <PictureOutlined style={{ color: 'rgba(255,255,255,0.3)', fontSize: 20 }} />
                  )}
                </div>
              ) : (
                /* TEXT */
                <span style={{ padding: '2px 6px', borderRadius: 3, whiteSpace: 'nowrap' }}>
                  {el.element_type === 'custom-text' ? (el.custom_text || '') : getElementValue(el, staff)}
                </span>
              )}
            </div>
          );
        })}
        
        {/* Link card URL text */}
        <div style={{
          position: 'absolute',
          bottom: '5px',
          left: '10px',
          fontSize: '7px',
          color: 'rgba(255,255,255,0.4)',
          zIndex: 10,
          maxWidth: '60%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
          {linkCardURL}
        </div>
      </div>
    );
  };

  const printAllCards = useReactToPrint({
    content: () => printRef.current,
    documentTitle: 'Staff_ID_Cards',
    pageStyle: `
      @page { size: A4 portrait; margin: 0; }
      @media print {
        body { margin: 0; padding: 0; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
        * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
        .print-page { width: 210mm !important; height: 297mm !important; page-break-after: always; break-after: page; padding: 8mm !important; box-sizing: border-box !important; }
        .print-page:last-child { page-break-after: auto; break-after: auto; }
      }
    `,
    copyStyles: true,
    onAfterPrint: () => message.success("បោះពុម្ពរួចរាល់!"),
  });

  const printSingleCard = useReactToPrint({
    content: () => singlePrintRef.current,
    documentTitle: 'Staff_ID_Card',
    onAfterPrint: () => message.success("បោះពុម្ពរួចរាល់!"),
  });

  if (!visible) return null;

  return (
    <>
      <Modal
        style={{ fontFamily: 'Content, sans-serif' }}
        title={
          <Space>
            <IdcardOutlined style={{ color: '#667eea' }} />
            <span>បញ្ជីកាតបុគ្គលិក ({savedStaffList?.length || 0} នាក់)</span>
          </Space>
        }
        open={visible}
        onCancel={onClose}
        width={1100}
        footer={[
          <Space key="footer" wrap>
            <Button danger onClick={onClear} icon={<DeleteOutlined />}>សម្អាតទាំងអស់</Button>
            <Button onClick={onClose}>បិទ</Button>
            <Button type="primary" icon={<PrinterOutlined />} onClick={() => printAllCards()} loading={loading} disabled={!templateData}>
              ព្រីនទាំងអស់ ({savedStaffList?.length || 0})
            </Button>
          </Space>
        ]}
        bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px', background: '#f5f5f5' }}
      >
        {/* Template Selector */}
        <div style={{ marginBottom: '20px', padding: '16px', background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <IdcardOutlined style={{ color: '#667eea', fontSize: '18px' }} />
            <span style={{ fontWeight: 'bold', color: '#333', fontSize: '14px' }}>ជ្រើសរើសពុម្ពកាត:</span>
          </div>
          <Select style={{ minWidth: '250px' }} value={selectedTemplateId} onChange={(value) => setSelectedTemplateId(value)} size="large" placeholder="Select a template">
            {templates.map(tpl => (
              <Option key={tpl.id} value={tpl.id}>
                <Space>{tpl.is_default === 1 && ''}{tpl.template_name}{tpl.is_default === 1 && <Tag color="gold" style={{ fontSize: '10px' }}>Default</Tag>}</Space>
              </Option>
            ))}
          </Select>
          {templateData && <Tag color="blue" style={{ fontSize: '12px' }}>{templateData.width} × {templateData.height} px | {templateData.orientation || 'landscape'}</Tag>}
        </div>

        {/* Content */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px' }}><Spin size="large" /><p style={{ marginTop: 16, color: '#666' }}>កំពុងផ្ទុកពុម្ពកាត...</p></div>
        ) : !templateData ? (
          <div style={{ textAlign: 'center', padding: '60px' }}><Empty description={<span>មិនមានពុម្ពកាត!<br />សូមបង្កើតពុម្ពកាតនៅក្នុង <strong>ID Card Designer</strong></span>} /></div>
        ) : savedStaffList?.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px' }}><Empty description="មិនមានបុគ្គលិកក្នុងបញ្ជី" /></div>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', justifyContent: 'center' }}>
            {savedStaffList.map((staff) => (
              <div key={staff.id} style={{ background: 'white', borderRadius: '16px', padding: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}
                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.15)'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <div onClick={() => { setSelectedStaff(staff); setPreviewVisible(true); }} style={{ cursor: 'pointer', borderRadius: '8px', overflow: 'hidden', marginBottom: '12px' }}>
                  <div style={{ transform: `scale(${Math.min(300 / cardSize.width, 200 / cardSize.height)})`, transformOrigin: 'top left', width: cardSize.width, height: cardSize.height, marginBottom: -(cardSize.height * (1 - Math.min(300 / cardSize.width, 200 / cardSize.height))), marginRight: -(cardSize.width * (1 - Math.min(300 / cardSize.width, 200 / cardSize.height))) }}>
                    {renderIDCard(staff)}
                  </div>
                </div>
                <div style={{ textAlign: 'center', fontFamily: 'Content, sans-serif' }}>
                  <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#1e8449', marginBottom: '4px' }}>{staff.fullname}</div>
                  <div style={{ fontSize: '11px', color: '#aaa', marginBottom: '8px' }}>{staff.department_name} | {staff.position_name}</div>
                  <Space size="small">
                    <Tooltip title="មើលកាត"><Button size="small" icon={<EyeOutlined />} onClick={() => { setSelectedStaff(staff); setPreviewVisible(true); }} style={{ borderRadius: '8px' }} /></Tooltip>
                 
                    <Tooltip title="ដកចេញ"><Button size="small" danger icon={<DeleteOutlined />} onClick={() => onRemove(staff.id)} style={{ borderRadius: '8px' }} /></Tooltip>
                  </Space>
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal>

      {/* Single Card Preview Modal */}
      <Modal
        title={<Space><EyeOutlined />{selectedStaff?.fullname} - {selectedStaff?.idnumber}</Space>}
        open={previewVisible}
        onCancel={() => setPreviewVisible(false)}
        footer={[<Space key="footer"><Button danger onClick={() => setPreviewVisible(false)}>បិទ</Button>
       
        </Space>]}
        width={cardSize.width + 100}
        bodyStyle={{ display: 'flex', justifyContent: 'center', padding: '30px', background: '#f0f2f5' }}
      >
        {selectedStaff && renderIDCard(selectedStaff)}
      </Modal>

      {/* Hidden print container */}
      <div style={{ display: 'none' }}>
        <div ref={printRef} className="print-all-container">
          {savedStaffList && (() => {
            const pad = 30, gap = 19;
            const a4W = 794, a4H = 1123;
            const cellW = (a4W - pad * 2 - gap) / 2;
            const cellH = (a4H - pad * 2 - gap * 2) / 3;
            const scale = Math.min(cellW / cardSize.width, cellH / cardSize.height);
            const scaledW = Math.floor(cardSize.width * scale);
            const scaledH = Math.floor(cardSize.height * scale);
            const pages = [];
            
            for (let i = 0; i < savedStaffList.length; i += 6) {
              const group = savedStaffList.slice(i, i + 6);
              const isLastPage = i + 6 >= savedStaffList.length;
              pages.push(
                <div key={i} className="print-page" style={{ width: `${a4W}px`, height: `${a4H}px`, padding: `${pad}px`, boxSizing: 'border-box', display: 'grid', gridTemplateColumns: `${scaledW}px ${scaledW}px`, gridTemplateRows: `repeat(3, ${scaledH}px)`, gap: `${gap}px`, justifyContent: 'center', alignContent: 'center', backgroundColor: 'white', overflow: 'hidden', pageBreakAfter: isLastPage ? 'auto' : 'always', breakAfter: isLastPage ? 'auto' : 'page' }}>
                  {group.map(staff => (
                    <div key={staff.id} style={{ width: `${scaledW}px`, height: `${scaledH}px`, overflow: 'hidden', flexShrink: 0 }}>
                      <div style={{ zoom: scale, width: `${cardSize.width}px`, height: `${cardSize.height}px`, WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
                        {renderIDCard(staff, true)}
                      </div>
                    </div>
                  ))}
                  {isLastPage && group.length < 6 && Array.from({ length: 6 - group.length }).map((_, idx) => (
                    <div key={`empty-${idx}`} style={{ width: `${scaledW}px`, height: `${scaledH}px`, border: '1px dashed #e0e0e0', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc' }}>
                      <PictureOutlined style={{ fontSize: '32px' }} />
                    </div>
                  ))}
                </div>
              );
            }
            return pages;
          })()}
        </div>
      </div>

      <div style={{ display: 'none' }}>
        <div ref={singlePrintRef}>
          {selectedStaff && renderIDCard(selectedStaff, true)}
        </div>
      </div>
    </>
  );
};

export default SavedCardsPreview;